export enum Routes {
    Login = '/login',
    Invalid = '/invalid',
    Showrooms = '/showrooms',
    Demos = '/demos',
    Blocks = '/blocks',
    Calendar = '/calendar',
    Reports = '/reports'
}